import type {
	FetchBaseQueryError,
	FetchBaseQueryMeta,
	QueryReturnValue,
} from "@reduxjs/toolkit/query";
import type { PaginatedParams, PaginatedResponse } from "../types.js";

export const loadAllPages = async <T>(
	loadPage: ({
		take,
		skip,
	}: PaginatedParams) => Promise<
		QueryReturnValue<
			PaginatedResponse<T>,
			FetchBaseQueryError,
			FetchBaseQueryMeta
		>
	>,
) => {
	const take = 10 * 1000;
	let hasMore = true;
	let skip = 0;
	const allItems: T[] = [];

	while (hasMore) {
		const result = await loadPage({ take, skip });

		if (result.error) {
			return result;
		}

		const page = result.data;

		allItems.push(...page.items);
		hasMore = take <= page.items.length;
		skip += page.items.length;
	}

	return {
		data: allItems,
	};
};
